import React from "react";
import { input } from "./Input.module.scss";
const Input = React.forwardRef((props, ref) => {
  const { className, ...rest } = props;
  if (rest.type === "textarea") {
    return <textarea ref={ref} {...rest} className={`${input} ${className}`} />;
  } else {
    return <input ref={ref} {...rest} className={`${input} ${className}`} />;
  }
});

export default Input;
